import React, { Component } from 'react';
import "./styles.css"
import { configuration } from './../../configuration'

class GraciasConPpto extends Component {

  render() {
    const clientImage = configuration().clientLogo
    // Required: Used in template string into configuration
    const year = new Date().getFullYear()  // Note: It can be used in gratitudeFooterText
    const gratitudeFooterText = eval('`' + configuration().gratitudeFooterText + '`')
    return (
      <div>
        <main role="main" className="container">
          <div className="gratitude-center-content">
            <img src={clientImage} className="img-fluid" alt="logo Syrsa"></img>
            <br /><br />
            <h1>¡Lo tenemos!</h1>
            <p className="lead">
              Muchas gracias por confiar en nosotros.
              <br />
              En un plazo inferior a {configuration().responseTime ? configuration().responseTime : '2'} horas te enviaremos el mejor presupuesto.
            </p>
          </div>
        </main>
        <div className="minifooter">
          <p>
            {gratitudeFooterText}
          </p>
        </div>

      </div>
    )
  }
}

export default GraciasConPpto;


// WEBPACK FOOTER //
// ./src/workflow/gratitude/gracias-con-ptto.js